import { List } from "immutable";
import { createSelector } from "reselect";

import { Content } from "../models/state/contents/Contents";

import * as contentsSelectors from "./state/contents";
import { getSectionContentIds, getAllContents } from "./state";

type State = any;

export function makeGetSectionContents(
  sectionId: string
): (arg0: State) => List<Content> {
  return createSelector(
    getAllContents,
    (state: any) => getSectionContentIds(state, sectionId),
    contentsSelectors.listExistingContents
  );
}
